// Query params used to suppress shopper-side side effects (analytics pixels,
// redirects) when a storefront is rendered inside the editor or a preview.
export const PRODUCT_FAMILIES_PARAM = 'siblings';
export function isProductFamiliesQueryEnabled(query) {
    if (query == null)
        return false;
    let raw;
    if (typeof query === 'string') {
        const search = query.startsWith('?') ? query.slice(1) : query;
        raw = new URLSearchParams(search).get(PRODUCT_FAMILIES_PARAM);
    }
    else if (query instanceof URLSearchParams) {
        raw = query.get(PRODUCT_FAMILIES_PARAM);
    }
    else {
        raw = query[PRODUCT_FAMILIES_PARAM];
    }
    const value = Array.isArray(raw) ? raw[0] : raw;
    return value === '1' || value === 'true';
}
export const IS_PREVIEW_PARAM = 'is-preview';
export const NO_PIXELS_PARAM = 'no-pixels';
export var EnrichmentMode;
(function (EnrichmentMode) {
    EnrichmentMode["SLIM"] = "slim";
    EnrichmentMode["CARD"] = "card";
    EnrichmentMode["FULL"] = "full";
})(EnrichmentMode || (EnrichmentMode = {}));
export const IS_EDITOR_PREVIEW_PARAM = 'is-editor-preview';
// Hides the Preview Mode banner without otherwise changing preview behavior.
// Used by the review screenshot so the LLM sees the page, not the overlay.
export const NO_PREVIEW_BANNER_PARAM = 'no-preview-banner';
// Suppresses the configured desktop redirect so a brand that sends desktop
// traffic to its own site can still open its storefront's desktop layout.
// Unlike the other params here it leaves pixels alone: the visit is real.
export const DESKTOP_PARAM = 'desktop';
// Hostname treated as "in preview" when no is-preview param is present.
export const PREVIEW_HOSTNAME = 'shop.blackcrow.ai';
/** Admin editor `selectedBlockIdx` for scrolling the preview to the shoppable video hero. */
export const EDITOR_SHOPPABLE_VIDEO_BLOCK_IDX = -1;
/** Admin editor `selectedBlockIdx` for scrolling the preview to the floating CTA footer. */
export const EDITOR_FLOATING_BUTTON_BLOCK_IDX = -2;
/** Admin editor `selectedBlockIdx` for scrolling the preview to the promotional banner header. */
export const EDITOR_BANNER_BLOCK_IDX = -3;
